import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { useCallback, type ComponentProps } from "react";
import type { Dayjs } from "dayjs";
import type { PickerChangeHandlerContext } from "@mui/x-date-pickers/models";
import type { DateValidationError } from "@mui/x-date-pickers/models";

export type SafeDatePickerProps = Omit<
  ComponentProps<typeof DatePicker>,
  "onChange"
> & {
  onChange?: (
    value: Dayjs | null,
    context: PickerChangeHandlerContext<DateValidationError>
  ) => void;
  onInvalidDate?: () => void;
};

export function SafeDatePicker({
  onChange,
  onInvalidDate,
  ...rest
}: SafeDatePickerProps) {
  const handleChange = useCallback(
    (
      value: Dayjs | null,
      context: PickerChangeHandlerContext<DateValidationError>
    ) => {
      const hasValidationError = context.validationError != null;
      const isValidValue = value == null || value.isValid();

      if (hasValidationError || !isValidValue) {
        onInvalidDate?.();
        return;
      }

      onChange?.(value, context);
    },
    [onChange, onInvalidDate]
  );

  return <DatePicker {...rest} onChange={handleChange} />;
}
